module.exports = __webpack_public_path__ + "static/media/twitter-logo.923455be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/twitter-logo.svg
// module id = 44
// module chunks = 0